module.exports = __webpack_public_path__ + "img/ZWE.45ac92c9.svg";